module.exports = __webpack_public_path__ + "static/media/fissura_fotos.b923e374.png";